// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2VCPn","title":"ClientReferral_title__29Hzq","itemText":"ClientReferral_itemText__1WmCT"};